import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Culture } from '../models/culture';
import { DefaultHttpService } from './default-http.service';
import { MemoryService } from './memory.service';

@Injectable({
    providedIn: 'root',
})
export class CultureService extends DefaultHttpService {
    constructor(
        private http: HttpClient,
        public override memoryService: MemoryService
    ) {
        super(memoryService);
    }

    List(): Observable<Culture[]> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            }),
        };

        // Appel de la Web Api
        return this.http.get<Culture[]>(this.baseUrl + `/api/cultures`, httpOptions).pipe(
            map((x) => {
                return x;
            })
        );
    }
}
